import React, { useState } from 'react';
import { Button, Input, Modal } from 'antd';
import './index.scss';
import * as api from '../../services/api';

const PCInputEmail = ({ visible, onClose,trailId,inviterId,state }: any) => {
  const [email,setEmailValue] = useState('')
  const [errMsg,setErrMsg] = useState('')
  const [showErr,setShowErr] = useState(false)
  const [disabled,setDisabled] = useState(false)
  const handleSubmit = async ()=>{
    if (!email.trim()) {
      setErrMsg('邮箱必填');
      setShowErr(true);
      return;
    }
    setDisabled(true)
    let result: any = await api.register(
      email.trim(),
      trailId,
      state,
      inviterId,
    );
    if (result.error) {
      setDisabled(false)
      setErrMsg(result.error);
      setShowErr(true);
      return;
    }
    if (result.body) {
      setDisabled(false)
      setEmailValue('')
      onClose(true,result.body.days)
      return;
    }
  }
  const emailValueChange = (value:any)=>{
    setEmailValue(value)
    if(value){
     setShowErr(false)
    }
  }
  return <Modal centered visible={visible} onCancel={onClose} closable={false} footer={null} width={328}>
    <div style={{ paddingBottom: 32,position:"relative" }}>
      <div style={{ fontSize: 17, fontWeight: 500, textAlign: 'center', marginBottom: 20 }}>填写邮箱</div>
      <div style={{position:"relative" }}>
      <Input value={email} onChange={e=>emailValueChange(e.target.value)} style={{ background: '#F0F0F0' }} size={'large'} placeholder={'输入邮箱号'}/>
      {
        showErr?<div style={{fontSize:12,fontWeight:500,color:'rgb(251, 76, 58)',position:'absolute',bottom:"-17px"}}>{errMsg}</div>:null
      }
      </div>

    </div>
    <div className={'islide-pc-modal-footer'}>
      <Button onClick={e=>{
        onClose();
        setEmailValue('')
      }}>取消</Button>
      <Button disabled={disabled} onClick={() => handleSubmit()}>确定</Button>
    </div>
  </Modal>;
};

export default PCInputEmail;
